export default {
  global: {
    'send': 'Invia',
    'save': 'Salva',
    'confirm': 'Conferma',
    'cancel': 'Cancella',
    'brand': 'HeiGIT - Heidelberg University',
    'close': 'Chiudi',
    'closeAndDoNotShowAgain': 'Chiudi e non mostrare più',
    'select': 'Seleziona',
    'yes': 'Si',
    'no': 'No',
    'and': 'e',
    'noAndDonAskAgain': 'NO (non chiedere più)',
    'ok': 'OK',
    'polygon': 'poligono',
    'developedByIntro': 'Servizio sviluppato dall',
    'developedBy': 'Heidelberg Institute for Geoinformation Technology',
    'duration': 'Durata',
    'distance': 'Distanza',
    'elevation': 'Altitudine',
    'profile': 'Profilo',
    'options': 'Opzioni',
    'parameters': 'Parametri',
    'custom': 'Personalizzato',
    'customOverlayer': 'Strato personalizzato',
    'rawRouting': 'Routing grezzo',
    'months': {
      'january': 'Gennaio',
      'february': 'Febbraio',
      'march': 'Marzo',
      'april': 'Aprile',
      'may': 'Maggio',
      'june': 'Giugno',
      'july': 'Luglio',
      'august': 'Agosto',
      'september': 'Settembre',
      'october': 'Ottobre',
      'november': 'Novembre',
      'december': 'Dicembre'
    },
    'monthsShort': {
      'january': 'Gen',
      'february': 'Feb',
      'march': 'Mar',
      'april': 'Apr',
      'may': 'Mag',
      'june': 'Giu',
      'july': 'Lug',
      'august': 'Ago',
      'september': 'Set',
      'october': 'Ott',
      'november': 'Nov',
      'december': 'Dic'
    },
    'units': {
      'km': 'km',
      'mi': 'mi',
      'm': 'm',
      'meters': 'metri',
      'seconds': 'seconds',
      's': 's',
      'minutes': 'minuti',
      'min': 'min',
      'hours': 'h',
      'days': 'g.',
      'lat': 'lat.',
      'lng': 'long.',
      'tones': 'toni',
      't': 't',
      'kmh': 'km/h'
    },
    'layers': {
      'macrocounty': 'Macro county',
      'country': 'Nazione',
      'region': 'Regione',
      'county': 'Provincia',
      'macroregion': 'Macro regione',
      'neighbourhood': 'Quartiere',
      'locality': 'Località',
      'borough': 'Comune',
      'localadmin': 'Amministratore locale',
      'address': 'Indirizzo',
      'street': 'Strada',
      'venue': 'Sede',
      'rawCoordinate': 'Coordinate long. lat.',
      'notAvailable': 'Non avviabile',
      'postalcode': 'Codice postale',
      'undefined': 'Non definito',
      'ocean': 'Oceano'
    },
    'population': 'Popolazione',
    'green': 'Verde',
    'noise': 'Rumore',
    'steepness': 'Ripidezza',
    'surface': 'Superficie',
    'roadaccessrestrictions': 'Restrizioni d\'accesso alla strada',
    'waytypes': 'Tipo di percorsi',
    'suitability': 'adeguatezza',
    'waycategory': 'Categoria di via',
    'tollways': 'Pedaggios',
    'traildifficulty': 'Difficoltà del sentiero',
    'osmid': 'OSM ID',
    'countryinfo': 'Informazioni sul paese'
  }
}
